import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../constants/site";
import { useLanguage } from "../i18n/LanguageContext";

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = pathname === "/" && !pastHero;

  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={buildWhatsAppLink(t.whatsapp.default_message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.tooltip}
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
      className={`fixed bottom-4 right-4 md:bottom-8 md:right-8 z-40 group transition-opacity duration-500 ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="relative flex items-center">
        <span className="hidden md:block absolute right-full mr-4 whitespace-nowrap font-sans-aw text-[10px] tracking-luxury uppercase text-black bg-white border border-black/15 px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          {t.whatsapp.tooltip}
        </span>
        <span className="flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-black text-white border border-white/30 hover:bg-white hover:text-black transition-colors duration-500">
          <MessageCircle strokeWidth={1.25} size={24} />
        </span>
      </div>
    </a>
  );
};
